export function removeLoading() {
	const form: HTMLFormElement | null = document.querySelector('#auth-form')
	if (form) {
		form.classList.remove('loading')
	} else {
		console.warn('No login form found')
	}
}
